import React from 'react';
import { Link } from "react-router-dom";
import Nav from './Nav';
import { useFavorites } from '../../hooks/use-favorites';
import { useComparison } from '../../hooks/use-comparison';

const HeaderOne = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';
    const { favoritesCount } = useFavorites();
    const { count: compareCount } = useComparison();

    return (
        <>
            <header className="main-header main-header-one clearfix">
                <div className="main-header-one__wrapper">
                    <div className="main-header-one__top">
                        <div className="container">
                            <div className="main-header-one__top-inner">
                                <div className="main-header-one__top-address">
                                    <ul>
                                        <li>
                                            <div className="icon"><span className="icon-pin"></span></div>
                                            <div className="text"><p>Southwest Florida</p></div>
                                        </li>
                                        <li>
                                            <div className="icon"><span className="icon-clock"></span></div>
                                            <div className="text"><p>Local Farm Fresh Produce</p></div>
                                        </li>
                                    </ul>
                                </div>

                                <div className="main-header-one__top-social-link">
                                    <ul>
                                        <li><a href="https://www.facebook.com/freshswfl" aria-label="Fresh SWFL on Facebook"><i className="icon-facebook-app-symbol"></i></a></li>
                                        <li><a href="https://www.instagram.com/freshswfl" aria-label="Fresh SWFL on Instagram"><i className="icon-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main-header-one__bottom">
                        <nav className="main-menu main-menu--1">
                            <div className="main-menu__wrapper">
                                <div className="container">
                                    <div className="main-menu__wrapper-inner">
                                        <div className="main-header-one__bottom-left">
                                            <div className="logo">
                                                <Link to={process.env.PUBLIC_URL + `/`}>
                                                    <span className="freshswfl-logo__lockup">
                                                        <img
                                                            className="freshswfl-logo__icon"
                                                            src={publicUrl + "favicon.svg"}
                                                            alt="FreshSWFL.com"
                                                        />
                                                        <span className="freshswfl-logo__text">
                                                            FRESHSWFL.COM
                                                            <span className="freshswfl-logo__tagline">Southwest Florida local food guide</span>
                                                        </span>
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>

                                        <div className="main-header-one__bottom-right">
                                            <Nav />

                                            {/* Phase 2: Header Actions */}
                                            <div className="freshswfl-header-actions">
                                                {/* Search Link */}
                                                <Link
                                                    to="/search"
                                                    className="freshswfl-icon-btn"
                                                    title="Search"
                                                    aria-label="Search"
                                                >
                                                    <span className="material-symbols-outlined" aria-hidden="true">search</span>
                                                </Link>

                                                {/* Favorites Link */}
                                                <Link
                                                    to="/favorites"
                                                    className="freshswfl-icon-btn"
                                                    title="Favorites"
                                                    aria-label="Favorites"
                                                >
                                                    <span className="material-symbols-outlined" aria-hidden="true">favorite</span>
                                                    {favoritesCount > 0 && (
                                                        <span className="freshswfl-icon-badge freshswfl-icon-badge--accent">
                                                            {favoritesCount > 99 ? '99+' : favoritesCount}
                                                        </span>
                                                    )}
                                                </Link>

                                                {/* Compare Link */}
                                                <Link
                                                    to="/compare"
                                                    className="freshswfl-icon-btn"
                                                    title="Compare Vendors"
                                                    aria-label="Compare Vendors"
                                                >
                                                    <span className="material-symbols-outlined" aria-hidden="true">compare_arrows</span>
                                                    {compareCount > 0 && (
                                                        <span className="freshswfl-icon-badge freshswfl-icon-badge--base">
                                                            {compareCount}
                                                        </span>
                                                    )}
                                                </Link>
                                            </div>

                                            <div className="main-header-one__bottom-right-btn ml-4">
                                                <Link to={process.env.PUBLIC_URL + `/browse`} className="thm-btn">
                                                    Browse Directory
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
        </>
    );
};

export default HeaderOne;
